import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation UpdateStaffRoles($organizationId: ID, $staffId: ID, $staffRoles: [UpdateStaffRole]) {
    updateStaffRoles(organizationId: $organizationId, staffId: $staffId, staffRoles: $staffRoles) {
      id
    }
  }
`;
